/**
 * Query keys shared between the component that reads them and the ones that
 * invalidate them, so a rename can't silently break the invalidation.
 */

/** Conversations with an unread message — the header's chat badge. */
export const UNREAD_MESSAGES_KEY = ['messages', 'unreadCount'];
